<h3 class="text--center mb-2">Why choose {{ client }}?</h3>
<ul>
  <dgx-cms-dynamic-component-outlet area="why_get_protected">
  </dgx-cms-dynamic-component-outlet>
</ul>
